import { Component, OnInit } from '@angular/core';
import {BsDatepickerConfig} from "ngx-bootstrap/datepicker";
import {DatePipe} from "@angular/common";
import {ApifirstService} from "../../service/apifirst.service";
import {NgbModal, NgbModalConfig} from "@ng-bootstrap/ng-bootstrap";
import {NgxSpinnerService} from "ngx-spinner";

@Component({
  selector: 'app-report-vin-mismatch',
  templateUrl: './report-vin-mismatch.component.html',
  styleUrls: ['./report-vin-mismatch.component.scss']
})
export class ReportVinMismatchComponent implements OnInit {

  fromDate: string | Date = '';
  toDate: string | Date = '';
  requestJson = {};
  reportID = '1006';
  maxDate: Date;
  bsConfig: Partial<BsDatepickerConfig>;
  bsConfigToDate: Partial<BsDatepickerConfig>;

  showFromDateError: boolean = false;
  fromDateErrorMessage: string = '';
  showToDateError: boolean = false;
  toDateErrorMessage: string = '';

  constructor(private datepipe: DatePipe, private apiService: ApifirstService,
              config: NgbModalConfig, private modalService: NgbModal,  private spinnerService: NgxSpinnerService) {
    this.maxDate = new Date();
    this.bsConfig = {
      dateInputFormat: 'DD.MM.YYYY',
      customTodayClass: 'custom-today-class',
      maxDate: this.maxDate
    };

    this.bsConfigToDate = {
      dateInputFormat: 'DD.MM.YYYY',
      customTodayClass: 'custom-today-class',
      maxDate: this.maxDate
    };
  }

  ngOnInit(): void { }


  onFromDateChange() {
    this.showFromDateError = false;
    this.fromDateErrorMessage = '';
    this.showToDateError = false;
    this.toDateErrorMessage = '';

    if (this.fromDate) {
      const selectedFromDate = new Date(this.fromDate);
      selectedFromDate.setHours(0, 0, 0, 0);

      const nextDayForToDate = new Date(selectedFromDate);
      nextDayForToDate.setDate(selectedFromDate.getDate() + 1);

      this.bsConfigToDate = { ...this.bsConfigToDate, minDate: nextDayForToDate };

      if (this.toDate) {
        const selectedToDate = new Date(this.toDate);
        selectedToDate.setHours(0, 0, 0, 0);

        if (selectedToDate <= selectedFromDate) {
          this.toDate = '';
          this.showToDateError = true;
          this.toDateErrorMessage = 'To date cannot be before or on the same day as from date';
        }
      }
    } else {
      this.bsConfigToDate = { ...this.bsConfigToDate, minDate: undefined };
      if (this.toDate) {
        this.showToDateError = false;
        this.toDateErrorMessage = '';
      }
    }
  }

  onToDateChange() {
    this.showToDateError = false;
    this.toDateErrorMessage = '';
    this.showFromDateError = false;
    this.fromDateErrorMessage = '';

    if (this.toDate) {
      const selectedToDate = new Date(this.toDate);
      selectedToDate.setHours(0, 0, 0, 0);

      const previousDayForFromDate = new Date(selectedToDate);
      previousDayForFromDate.setDate(selectedToDate.getDate() - 1);

      this.bsConfig = { ...this.bsConfig, maxDate: previousDayForFromDate };

      if (this.fromDate) {
        const selectedFromDate = new Date(this.fromDate);
        selectedFromDate.setHours(0, 0, 0, 0);

        if (selectedFromDate >= selectedToDate) {
          this.fromDate = '';
          this.showFromDateError = true;
          this.fromDateErrorMessage = 'From date cannot be after or on the same day as to date';
        }
      }
    } else {
      this.bsConfig = { ...this.bsConfig, maxDate: this.maxDate };
      if (this.fromDate) {
        this.showFromDateError = false;
        this.fromDateErrorMessage = '';
      }
    }
  }

  downloadVinMismatchReport(apiErrorPopup: any) {
    this.showFromDateError = false;
    this.fromDateErrorMessage = '';
    this.showToDateError = false;
    this.toDateErrorMessage = '';

    let validationFailed = false;

    if (!this.fromDate) {
      this.showFromDateError = true;
      this.fromDateErrorMessage = 'Please enter the from date';
      validationFailed = true;
    }

    if (!this.toDate) {
      this.showToDateError = true;
      this.toDateErrorMessage = 'Please enter the to date';
      validationFailed = true;
    }

    if (this.fromDate && this.toDate) {
      const from = new Date(this.fromDate);
      const to = new Date(this.toDate);
      from.setHours(0, 0, 0, 0);
      to.setHours(0, 0, 0, 0);
      if (from >= to) {
        this.showFromDateError = true;
        this.fromDateErrorMessage = 'From date cannot be after or on the same day as to date';
        validationFailed = true;
      }
    }

    if (validationFailed) {
      return;
    }

    this.spinnerService.show();

    this.requestJson = {
      'fromDate': (this.datepipe.transform(this.fromDate, 'yyyy-MM-dd') === null) ? '' :
        this.datepipe.transform(this.fromDate, 'yyyy-MM-dd'),
      'toDate': (this.datepipe.transform(this.toDate, 'yyyy-MM-dd') === null) ? '' :
        this.datepipe.transform(this.toDate, 'yyyy-MM-dd'),
    };
    this.apiService.generateReport(this.requestJson,this.reportID).subscribe(
      (data) => { console.log('BE part');
        const headers = data.headers;
        const contentDisposition = headers.get('Content-Disposition');
        const filename = contentDisposition ? contentDisposition.split('=')[1] : 'default-filename.csv';
        const blob = new Blob([data.body || ''], { type: 'text/csv' });
        if (window.navigator.msSaveOrOpenBlob)
        {
          window.navigator.msSaveBlob(blob, filename);
        }
        else {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          document.body.appendChild(a);
          a.style.display = 'none';
          a.href = url;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(url);

        }
        this.spinnerService.hide();
      },
      (err) => {
        this.spinnerService.hide();
        this.modalService.open(apiErrorPopup, { size: 'lg' });
      });
  }
}
